// Formatação/máscara de dinheiro (pt-BR). O campo trabalha em CENTAVOS: cada
// dígito digitado empurra a vírgula (mesmo comportamento da máscara
// "#.##0,00 reverse" do legado) — assim "350000" nunca é ambíguo com
// "350.000" (milhar) na hora do servidor interpretar.

const formatoBR = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export function mascararDinheiro(digitado) {
  const digitos = String(digitado ?? '').replace(/\D/g, '');
  if (!digitos) return '';
  return formatoBR.format(Number(digitos) / 100);
}

// número vindo do banco (350000.5) → "350.000,50"
export function numeroParaCampo(numero) {
  if (numero === null || numero === undefined || numero === '') return '';
  const n = Number(numero);
  return Number.isFinite(n) ? formatoBR.format(n) : '';
}

// "350.000,50" → 350000.5 (só pra exibir o preço por m² na tela)
export function campoParaNumero(texto) {
  if (!texto) return null;
  const n = Number(String(texto).replace(/\./g, '').replace(',', '.'));
  return Number.isFinite(n) ? n : null;
}

const moeda = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
export const formatarMoeda = (n) => (n === null || n === undefined || n === '' || Number(n) === 0 ? '—' : moeda.format(Number(n)));

export function formatarDataHora(iso) {
  if (!iso) return '';
  const partes = String(iso).match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/);
  return partes ? `${partes[3]}/${partes[2]}/${partes[1]} ${partes[4]}:${partes[5]}` : iso;
}

// "Cadastrado em 26/10/2026 14:30 · Atualizado em 27/10/2026 09:12" (só "Cadastrado" se nunca foi alterado depois)
export function textoDatasImovel(im) {
  const criado = formatarDataHora(im?.created_at);
  if (!criado) return '';
  const atualizado = formatarDataHora(im?.updated_at);
  return atualizado && atualizado !== criado ? `Cadastrado em ${criado} · Atualizado em ${atualizado}` : `Cadastrado em ${criado}`;
}

export function enderecoCurto(im) {
  const rua = [im.i1_endereco, im.i1_numero].filter(Boolean).join(', ');
  const cidade = [im.i1_cidade, im.i1_estado].filter(Boolean).join(', ');
  return { rua, bairro: im.i1_bairroofi || '', cidade };
}

// Movido de ListaImoveis.js (22/10/2026) pra ser reaproveitado também na busca geral do
// Dashboard e na lista de "imóveis vinculados" do cliente — ver TabelaImoveis.js.
export function statusDoImovel(im) {
  if (im.i1_rascunho === 'true') return { cor: '#9e9e9e', fundo: '#e6e6e6', rotulo: 'Incompleto', bg: 'secondary' };
  if (im.i1_situacao === 'Ativo') return { cor: '#2e9e4f', fundo: undefined, rotulo: 'Ativo', bg: 'success' };
  return { cor: '#d9534f', fundo: '#fbdddd', rotulo: im.i1_situacao || 'Inativo', bg: 'danger' };
}
